import React, { useState } from 'react';

import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  Button,
  useMediaQuery,
  useTheme,
  InputLabel,
  Avatar,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



import SingleDateWithoutArrow from '../../components/Date-range-picker/SingleDateWithoutArrow';


import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FilterwIcon } from '../../icons';

import FilterListIcon from '@mui/icons-material/FilterList';


import SingleSelectDroupdown from '../../components/Projects/project-components/SingleSelectDroupdown';
import TeamSelectDroupDown from '../../components/Projects/project-components/TeamSelectDroupDown';

import MultiClientSelect from '../../components/DemoTabs/MultiClientSelect';

import ClientImageSelect from '../../components/DemoTabs/ClientImageSelect';
import ActivityLevel from '../../components/DemoTabs/ActivityLevel';
import SelectDropDowns from '../../components/DemoTabs/SelectDropDowns';
import SelectSearchDroupDown from '../../components/DemoTabs/SelectSearchDroupDown';




const FilterSidebar = ({ open, onClose, title = 'Filters', children }) => {








  // Project Seclect Single 
  const [selectedProject, setSelectedProject] = useState(null);
  // Project Seclect Single 



  // Project Seclect Single 
  const [selectedTeamsAll, setSelectedTeamsAll] = useState(null);
  // Project Seclect Single 


  // start Projects 
  const [selectedClients, setSelectedClients] = React.useState([]);
  const allClients = [
    { name: 'Client Name 1', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: 'Client Name 2', image: null },
    { name: 'Client Name 3', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
    { name: 'Client Name 4', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: 'Client Name 5', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
    { name: 'Client Name 6', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
  ];
  // End Projects 

  // start Members 

  const [selectedUsers, setSelectedUsers] = useState([]);

  const users = [
    { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: 'Alice Smith', image: null },
    { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
    { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
    { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
  ];


  // start activity level 
  const [selectedActivityLevel, setSelectedActivityLevel] = useState('');

  const ActivityLevelData = [
    { name: '95 %', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: '90 %', image: null },
    { name: '85 %', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
    { name: '80 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: '75 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: '70 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: '60 %', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
  ];
  // End activity level 

  // start Time worked 
  const [selectedTimeWorked, setSelectedTimeWorked] = useState('');

  const TimeWorkedData = [
    { name: 'Select' },
    { name: 'With time tracked' },
    { name: 'With no time tracked' },
  ];

  // End  Time worked 


  // start All Role
  const [selectedAllRole, setSelectedAllRole] = useState('');

  const AllRoleData = [
    { name: 'Organization owner' },
    { name: 'Organization manager' },
    { name: 'Project manager' },
    { name: 'User' },
    { name: 'Project viewer' },
  ];

  // End  All Role

  // start All Department
  const [selectedAllDepartment, setSelectedAllDepartment] = useState('');

  const AllDepartmentData = [
    { name: 'Marketing Coordinator' },
    { name: 'Medical Assistant' },
    { name: 'Trainer' },
    { name: 'President of Sales' },

  ];

  // End  All Department



  // start Employment Type
  const [selectedEmploymentType, setSelectedEmploymentType] = useState('');

  const EmploymentTypeData = [
    { name: 'Contractor - hourly' },
    { name: 'Contractor - fixed rate' },
    { name: 'Contractor - project based' },
    { name: 'FTE - hourly (full-time employee)' },
    { name: 'FTE - salary (full-time employee)' },
  ];

  // End  Employment Type




  // start Time Tracking
  const [selectedTimeTracking, setSelectedTimeTracking] = useState('');

  const TimeTrackingData = [
    { name: 'All' },
    { name: 'Enabled' },
    { name: 'Disabled' },
  ];

  // End  Time Tracking


  // start Currency
  const [selectedCurrency, setSelectedCurrency] = useState('');

  const CurrencyData = [
    { name: 'Select' },
    { name: 'United States Dollars' },
    { name: 'United Kingdom Pounds' },
    { name: 'Algeria Dinars' },
    { name: 'Argentina Pesos(Peso argentino)' },
    { name: 'Australia Dollars' },
    { name: 'Bahamas Dollars' },
    { name: 'Lebanon Pounds' },
    { name: 'Malaysia Ringgit(Ringgit Malaysia)' },
    { name: 'South Africa Rand' },
    { name: 'Singapore Dollars' },
  ];

  // End  Currency



  // start Country
  const [selectedCountry, setSelectedCountry] = useState('');

  const CountryData = [
    { name: 'All' },
    { name: 'United States' },
    { name: 'Canada' },
    { name: 'India' },
    { name: 'Germany' },
    { name: 'Australia' },
  ];

  // End  Country


  // start State
  const [selectedState, setSelectedState] = useState('');

  const StateData = [
    { name: 'All Time' },
    { name: 'California' },
    { name: 'Texas' },
    { name: 'New York' },
    { name: 'Florida' },
    { name: 'Illinois' },
  ];

  // End  State

  // start Home Country
  const [selectedHomeCountry, setSelectedHomeCountry] = useState('');

  const HomeCountryData = [
    { name: 'All' },
    { name: 'United States' },
    { name: 'Canada' },
    { name: 'India' },
    { name: 'Australia' },
    { name: 'Germany' },
  ];

  // End  Home Country


  // start Home Country
  const [selectedHomeState, setSelectedHomeState] = useState('');

  const HomeStateData = [
    { name: 'All Time' },
    { name: 'California' },
    { name: 'Texas' },
    { name: 'New York' },
    { name: 'Florida' },
    { name: 'Washington' },
  ];

  // End  Home Country






  // export default function FilterPopup() {
  const [setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };







  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '400px',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          p: 0,
          borderTopLeftRadius: '20px',
          borderBottomLeftRadius: '20px',
          overflow: 'visible',
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #E0E0E0',
          position: 'sticky'
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <Box onClick={onClose}
          style={{
            position: 'absolute', backgroundColor: '#fff', borderRadius: '100px', boxShadow: '0px 1px 6px 2px #00000030', height: '32px',
            width: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', left: '-12px', bottom: '-16px', cursor: 'pointer',
            zIndex: 10,
          }}>
          <ChevronRightIcon fontSize="small" />
        </Box>
      </Box>

      {/* Scrollable Body */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          p: 3,
        }}
      >

        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: '16px', color: '#0076FE', fontWeight: '600', fontFamily: 'Manrope', margin: '0 auto 24px' }}><img src='./assets/images/app-activity/popup-icon/organization-icon.svg' className='img-fluid' alt='organization icon' />
          Organization</Typography>
        {/* start All Role */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Role</InputLabel>
          <SelectDropDowns label="All" options={AllRoleData} selectedValue={selectedAllRole} onChange={setSelectedAllRole} />
        </Box>

        {/* End All Role */}


        {/* start Projects sec  */}
        <Box sx={{ pb: 0, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Projects</InputLabel>
          <SingleSelectDroupdown
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
          />

        </Box>
        {/* End Projects sec  */}


        {/* start Teams sec  */}
        <Box sx={{ pb: 0, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Teams</InputLabel>
          <TeamSelectDroupDown
            selectedTeamsAll={selectedTeamsAll}
            setSelectedTeamsAll={setSelectedTeamsAll}
          />
        </Box>
        {/* End Teams sec  */}



        {/* start All Department */}
        <Box sx={{ pb: 0, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Department</InputLabel>
          <SelectDropDowns label="All" options={AllDepartmentData} selectedValue={selectedAllDepartment} onChange={setSelectedAllDepartment} />
        </Box>

        {/* End All Department */}

        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: '16px', color: '#0076FE', fontWeight: '600', fontFamily: 'Manrope', margin: '24px auto 24px' }}>
          <img src='./assets/images/app-activity/popup-icon/employment-icon.svg' className='img-fluid' alt='employment icon' />
          Employment</Typography>

        {/* start Employment Type */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Employment Type</InputLabel>
          <SelectDropDowns label="All" options={EmploymentTypeData} selectedValue={selectedEmploymentType} onChange={setSelectedEmploymentType} />
        </Box>

        {/* End Employment Type */}

        {/* start Date Added */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Date Added</InputLabel>
          <SingleDateWithoutArrow />
        </Box>

        {/* End Date Added */}

        {/* start Date removed */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Date removed</InputLabel>
          <SingleDateWithoutArrow />
        </Box>

        {/* End Date removed */}

        {/* start Time Tracking Status */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Time Tracking Status </InputLabel>
          <SelectDropDowns label="All" options={TimeTrackingData} selectedValue={selectedTimeTracking} onChange={setSelectedTimeTracking} />
        </Box>

        {/* End Time Tracking Status */}

        {/* start Currency */}
        <Box sx={{ pb: 0, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Currency </InputLabel>
          <SelectDropDowns label="Select" options={CurrencyData} selectedValue={selectedCurrency} onChange={setSelectedCurrency} />
        </Box>

        {/* End Currency */}

        <Typography display="flex" alignItems="center" sx={{ gap: '8px', fontSize: '16px', color: '#0076FE', fontWeight: '600', fontFamily: 'Manrope', margin: '24px auto 24px' }}>
          <img src='./assets/images/app-activity/popup-icon/location-icon.svg' className='img-fluid' alt='location icon' />
          Location</Typography>


        <Typography sx={{ fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', margin: '24px auto 24px' }}>Location</Typography>

        {/* start Work country / region */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Work country / region </InputLabel>
          <SelectSearchDroupDown label="All" options={CountryData} selectedValue={selectedCountry} onChange={setSelectedCountry} />
        </Box>

        {/* End Work country / region */}

        {/* start Work state / province */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Work state / province </InputLabel>
          <SelectSearchDroupDown label="All Time" options={StateData} selectedValue={selectedState} onChange={setSelectedState} />
        </Box>

        {/* End Work state / province */}

        {/* start Home country / region */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Home country / region </InputLabel>
          <SelectSearchDroupDown label="All" options={HomeCountryData} selectedValue={selectedHomeCountry} onChange={setSelectedHomeCountry} />
        </Box>

        {/* End Home country / region */}

        {/* start Home state / province */}
        <Box sx={{ pb: 2, }}>
          <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Home state / province </InputLabel>
          <SelectSearchDroupDown label="All Time" options={HomeStateData} selectedValue={selectedHomeState} onChange={setSelectedHomeState} />
        </Box>

        {/* End Home state / province */}
      </Box>


      {/* Fixed Footer */}
      <Box display="flex" justifyContent="center"
        sx={{
          p: 3,
          borderTop: '1px solid #E0E0E0',
        }}
      >


        <Button onClick={onClose} variant="outlined" fullWidth={isMobile}
          sx={{ backgroundColor: '#fff', textTransform: 'capitalize', color: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: 500, height: '50px', border: '1px solid #9095A1', borderRadius: '8px', fontFamily: 'Manrope' }}>
          Clear Filter
        </Button>


        {/* <Button
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mb: 1, textTransform: 'capitalize' }}
        >
          Apply Filters
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onClose}
          sx={{ textTransform: 'capitalize' }}
        >
          Cancel
        </Button> */}
      </Box>
    </Drawer>
  );
};

export default FilterSidebar;
